import React from 'react';
import { motion } from 'framer-motion';
import { resultadosEsperados } from '../data/resultados';
export function ResultsTimeline() {
  return <section className="w-full bg-gray-50 px-6 py-20 sm:px-10" data-id="element-158" data-mp="1y73h655pvfa9">
      <div className="mx-auto max-w-5xl" data-id="element-159" data-mp="234v7wvumkvcv">
        <h2 className="text-center font-heading text-3xl font-bold text-mint-dark sm:text-4xl" data-id="element-160" data-mp="2380zchqq89br">
          Qué podés esperar, semana a semana
        </h2>
        <p className="mt-3 text-center text-base text-gray-500" data-id="element-161" data-mp="2c5l1ru0bsbny">Un timeline realista, no promesas mágicas</p>

        <div className="relative mt-14 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6" data-id="element-162" data-mp="2h4efnnjiy4on">
          <div className="pointer-events-none absolute left-0 right-0 top-5 hidden h-px bg-gray-200 lg:block" aria-hidden="true" data-id="element-163" data-mp="2lxqu54uhov3o" />

          {resultadosEsperados.map((etapa, index) => {
          const isLast = index === resultadosEsperados.length - 1;
          return <motion.div key={etapa.semana} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.3,
            delay: index * 0.08,
            ease: [0.23, 1, 0.32, 1]
          }} className="relative flex flex-col items-center text-center" data-id="element-164" data-mp="2zx8kvprciifo" data-mpi={index}>
                <span className={`relative z-10 flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold ${isLast ? 'bg-mint-dark text-white ring-4 ring-mint-deep' : 'bg-white text-mint-dark ring-2 ring-mint'}`} data-id="element-165" data-mp="3s5520me7ph58">
                  {index + 1}
                </span>
                <p className={`mt-4 text-xs font-bold uppercase tracking-wide ${isLast ? 'text-mint-dark' : 'text-gray-400'}`} data-id="element-166" data-mp="exl8tuxh15tl">
                  {etapa.semana}
                </p>
                <p className={`mt-1 font-heading text-lg font-bold ${isLast ? 'text-mint-dark' : 'text-gray-800'}`} data-id="element-167" data-mp="1cf216l15vfme">
                  {etapa.titulo}
                </p>
                <p className="mt-2 max-w-[220px] text-sm text-gray-500" data-id="element-168" data-mp="31uml2pfhx3r8">{etapa.descripcion}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}